<template>
    <Toast >
        <template #container="{message, closeCallback}">

            <div class="position-relative d-flex align-items-center gap-2">
                <div>
                    <i class=" material-icons-round fsz-20 icon"
                  >{{ icons[message.severity] }}</i>
                </div>
               <div>
                <h6 class="toast-title">
                    {{ message.summary }}
                </h6>
                <p class="toast-detail">
                    {{ message.detail }}
                </p>
               </div>
               <i  @click="closeCallback" class="close-icon material-symbols-rounded fsz-20">close</i>

            </div>
         
        </template>
    </Toast>
<!-- 
    <div :class="`toast toast-type toast-type-${props.severity}`">
        <div class="position-relative d-flex align-items-center gap-2">
            <div>
                <component
                :is="icons[`${props.severity}`]"
                class="icon"
              ></component>
            </div>
                
            
           <div>
            <h6 class="toast-title">
                {{ props.summary }}
            </h6>
            <p class="toast-detail">
                {{ props.detail }}
                <nuxt-link class="toast-link" :to="props.url">
                    Link to follow
                </nuxt-link>
            </p>
           </div>
        </div>
        <i  class="close-icon material-symbols-rounded fsz-20">close</i>
    </div> -->
</template>

<script setup lang="ts">
const icons: any = reactive({
info: 'info',
success: 'check_circle',
warning: 'warning',
error: 'error'
});


</script>

<style scoped>

</style>